<script>
    import { fly } from "svelte/transition";
    import { Button,DatePicker,CascadePicker } from '../index'
    let show = false;
    let showcas = false;
    let type = 'day'
    let title = "请选择"
    function hanleShow(types){
        show = true
        type = types
    }

    function hanleCas(){
        showcas = true
    }

    function handleConfirm(){
        show = false
    }

    function handleCancel(){
        show = false
    }
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础</h4>
    <div class="example-body">
        <Button on:click={()=>hanleShow("day")}>选择</Button>
    </div>
    <h4 class="example-title">年</h4>
    <div class="example-body">
        <Button on:click={()=>hanleShow("year")}>选择</Button>
    </div>
    <h4 class="example-title">月</h4>
    <div class="example-body">
        <Button on:click={()=>hanleShow("month")}>选择</Button>
    </div>

    <h4 class="example-title">级联</h4>
    <div class="example-body">
        <Button on:click={()=>hanleCas("year")}>选择</Button>
    </div>
</div>



<DatePicker precision={type} on:confirm={handleConfirm} on:cancel={handleCancel} {title} {show}></DatePicker>

<CascadePicker show={showcas} on:confirm={(e)=>{
    console.log(e.detail)
    showcas=false
}} on:cancel={()=>showcas=false} />

<style lang="less">
    @import "./example.less";
</style>
